import { TFunction } from "react-i18next";
import { SaleOrdersBackendAcceptableParams } from "../pages/services/types";
import { ORDERS_DEFAULT_EXPORT_COLUMNS, importDefaultOrderTypes, importOrderDateMatchTypes } from "./constants";

export const getDefaultOrderTypesInputOptions = (t: TFunction) =>
	importDefaultOrderTypes.map((defaultOrderType) => ({
		value: defaultOrderType,
		label: t(`enums.orders.types.${defaultOrderType}`),
	}));

export const getOrderDateMatchTypesInputOptions = (t: TFunction) =>
	importOrderDateMatchTypes.map((orderDateMatchType) => ({
		value: orderDateMatchType,
		label: t(`enums.orders.date_match_types.${orderDateMatchType}`),
	}));

export const getOrdersListExportParams = (params?: Record<string, any>) => {
	const newParams = {
		...params,
		columns: params?.columns || ORDERS_DEFAULT_EXPORT_COLUMNS,
	};
	const newParamsArr = newParams.columns.split(",");
	const convertedParams = newParamsArr.flatMap((param: string) => {
		switch (param) {
			case "TOTAL_PRICE":
				return [
					SaleOrdersBackendAcceptableParams.TOTAL_AMOUNT,
					SaleOrdersBackendAcceptableParams.PAYMENT_METHODS,
				];
			case "SUB_TOTAL_PRICE":
				return SaleOrdersBackendAcceptableParams.SUB_TOTAL_AMOUNT;
			case "EXECUTION_AT":
				return SaleOrdersBackendAcceptableParams.EXECUTION_DATE;
			case "DELIVERY_EMPLOYEE":
				return SaleOrdersBackendAcceptableParams.EMPLOYEE_DELIVERY;
			case "SOURCE_NUMBER":
				return SaleOrdersBackendAcceptableParams.EXTERNAL_NUMBER;
			case "TABLE":
				return SaleOrdersBackendAcceptableParams.ROOM_TABLE;
			default:
				return param;
		}
	});
	const paramsToBeSent = convertedParams.filter((param: string) => param !== "");

	return { ...newParams, columns: paramsToBeSent.join(",") };
};
